<template>
  <div>
    <div class="search-box">
      <el-input
        style="width: 300px; margin-right: 10px"
        v-model.trim="queryStr"
        clearable
        placeholder="产品名称/心愿单编号/联系人"
        @keyup.13.native="onSearch"
      />
      <el-button type="primary" @click="onSearch">查询</el-button>
      <el-button type="primary" @click="onReset">清空</el-button>
    </div>
    <div class="cml-button-group">
      <el-button
        type="primary"
        @click="createBtn"
        v-hasPermission="'own-manage/wish-list-create'"
      >新增</el-button>
      <el-button
        type="primary"
        @click="updateBtn"
        :disabled="selectData.length !== 1"
        v-hasPermission="'own-manage/wish-list-update'"
      >修改</el-button>
      <el-button
        type="primary"
        :disabled="selectData.length === 0"
        @click="deleteBtn"
        v-hasPermission="'own-manage/wish-list-delete'"
      >删除</el-button>
    </div>
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHead"
      :tableData="tableData"
      @page-size-change="pageSizeChange"
      @select-change="selectChange"
    >
      <template #code="{row}">
        <el-button type="text" @click="getDetail(row)">{{ row.code }}</el-button>
      </template>
    </CommonTable>
    <el-dialog
      :close-on-click-modal="false"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="90%"
      top="8vh"
    >
      <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" :disabled="formType==='detail'">
        <el-row>
          <el-col :span="6">
            <el-form-item label="产品名称" prop="productName">
              <el-input v-model="formData.productName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否定制" prop="izCustomized">
              <el-radio-group v-model="formData.izCustomized">
                <el-radio label="YES">是</el-radio>
                <el-radio label="NO">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="定制方向" prop="customizedDirection" :rules="[{
              required: formData.izCustomized === 'YES',
              message: '请输入定制方向',
              trigger: 'blur'
            }]">
              <el-input v-model="formData.customizedDirection" :disabled="formData.izCustomized==='NO'"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="数量" prop="quantity">
              <CustomNumInput
                :value="formData.quantity"
                :limitNum="2"
                @change-emit="val => (formData.quantity = val)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="期望交付时间" prop="expectedDeliveryDate">
              <el-date-picker
                v-model="formData.expectedDeliveryDate"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="材质" prop="material">
              <el-input v-model="formData.material"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="工艺" prop="technology">
              <el-input v-model="formData.technology"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="参考方向" prop="referenceDirection">
              <el-input v-model="formData.referenceDirection"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="颜色要求" prop="colorRequire">
              <el-input v-model="formData.colorRequire"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="到货仓库" prop="arrivalWarehouse">
              <el-input v-model="formData.arrivalWarehouse"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="预算单价" prop="budgetUnitPrice">
              <CustomNumInput
                :value="formData.budgetUnitPrice"
                :limitNum="2"
                @change-emit="val => (formData.budgetUnitPrice = val)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系人" prop="contacts">
              <el-input v-model="formData.contacts" placeholder="请输入花名验证" @blur="contactsBlur"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="需求部门" prop="demandDepartment">
              <el-input
                v-model="formData.demandDepartment"
                disabled
                placeholder="根据联系人带出"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="13">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="formData.remark" type="textarea"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item label="产品需求详情" prop="productDetail">
              <TextareaEditor ref="TextareaEditor" :height="250"  v-if="dialogVisible" />
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item label="附件">
              <UploadFile
                ref="uploadMultipleRef"
                btnName="附件"
                :multiple="true"
                :maxSize="100"
                excelFileExtend=".pdf,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.png"
                showTips="支持DOC、DOCX、XLS、XLSX、PDF、JPEG、JPG、PNG格式文件"
                @file-list-change="fileListChange"
              ></UploadFile>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" v-if="formType !== 'detail'">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="saveBtn" :loading=saveLoading>提交心愿单</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="detailDialogVisible"
      width="90%"
      top="5vh"
    >
      <el-form :model="formData" ref="formData" label-width="120px" style="max-height: 700px; overflow: scroll">
        <el-divider><h3 style="color: #ab0033">心愿单信息</h3></el-divider>
        <el-row>
          <el-col :span="6">
            <el-form-item label="模块" prop="moduleName">
              <b>{{ formData.moduleName }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="名称" prop="productName">
              <b>{{ formData.productName }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系人" prop="contacts">
              <b>{{ formData.contacts }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="需求部门" prop="demandDepartment">
              <b>{{ formData.demandDepartment }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="数量" prop="quantity">
              <b>{{ formData.quantity }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="期望交付时间" prop="expectedDeliveryDate">
              <b>{{ formData.expectedDeliveryDate }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="材质" prop="material">
              <b>{{ formData.material }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="工艺" prop="technology">
              <b>{{ formData.technology }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否定制" prop="izCustomizedName">
              <b>{{ formData.izCustomizedName }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="定制方向" prop="customizedDirection">
              <b>{{ formData.customizedDirection }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="参考方向" prop="referenceDirection">
              <b>{{ formData.referenceDirection }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="颜色要求" prop="colorRequire">
              <b>{{ formData.colorRequire }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="到货仓库" prop="arrivalWarehouse">
              <b>{{ formData.arrivalWarehouse }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="预算单价" prop="budgetUnitPrice">
              <b>{{ formData.budgetUnitPrice }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <b>{{ formData.remark }}</b>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="附件" prop="demandDepartment">
              <p class="file-list-item">
                <span
                  v-for="(el, index) in formData.files"
                  :key="index"
                >
                <el-popover
                  placement="top"
                  trigger="hover"
                  :disabled="popoverDisabled"
                  >
                    <div>
                      <el-button type="text" icon="el-icon-view" @click="previewBtn(el)">预览</el-button>
                      <el-button type="text" icon="el-icon-download" @click="downloadFile(el)">下载</el-button>
                    </div>
                    <p slot="reference">
                      <i class="el-icon-document"></i>
                      {{ el.name }}
                    </p>
                </el-popover>
                </span>
              </p>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="需求详情">
              <div v-html="formData.productDetail"></div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="detailDialogVisible=false" type="primary">关闭</el-button>
      </span>
    </el-dialog>
    <PreviewFileDialog :type="fileType" :url="fileUrl" ref="PreviewFileDialog" />
  </div>
</template>
<script>
import { WISH_MODULE } from './static.js'
import CommonTable from '@/components/CommonTable';
import CustomNumInput from '@/components/CustomNumInput';
import UploadFile from '@/components/Upload/UploadFile.vue';
import TextareaEditor from '@/components/TextareaEditor';
import PreviewFileDialog from '@/components/previewFileDialog';
import download from '@/utils/download';

export default {
  props: {
    activeName: {
      type: String,
      required: true
    },
    activeValue: {
      type: String,
      required: true
    }
  },
  components: {
    CommonTable,
    CustomNumInput,
    UploadFile,
    TextareaEditor,
    PreviewFileDialog
  },
  data() {
    return {
      dialogTitle: '',
      formType: '',
      queryStr: '',
      tableLoading: false,
      selectData: [],
      tableParam: {
        pageNo: 1,
        pageSize: 20,
      },
      tableData: {
        list: []
      },
      tableHead: [],
      formData: {},
      rules: {
        productName: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        izCustomized: [{ required: true, message: '请选择是否定制', trigger: 'change' }],
        quantity: [{ required: true, message: '请输入数量', trigger: 'blur' }],
        expectedDeliveryDate: [{ required: true, message: '请选择期望交付时间', trigger: 'blur' }],
        contacts: [{ required: true, message: '请输入联系人', trigger: 'blur' }]
      },
      dialogVisible: false,
      saveLoading: false,
      fileUrl: '',
      fileType: '',
      detailDialogVisible: false,
      popoverDisabled: false
    };
  },
  mounted() {
    this.$refs.CommonTable.changeHeight();
    this.tableHead = WISH_MODULE[this.activeValue].tableHead;
    this.getTableList();
  },
  methods: {
    downloadFile({name, url}) {
      download(url, name);
    },
    // 预览文件
    previewBtn({name, url}) {
      // 隐藏popover弹窗
      this.popoverDisabled = true;
      setTimeout(() => {
        this.popoverDisabled = false;
      }, 500);
      const fileExtend = name.substring(name.lastIndexOf('.')).toLowerCase();
      const type = ['.png','.jpeg','.jpg'].includes(fileExtend) ? 'img' : 'file';
      this.fileUrl = url;
      this.fileType = fileExtend.indexOf('pdf') > -1 ? 'pdf' : type;
      this.$refs.PreviewFileDialog.dialogVisible = true;
    },
    getDetail (row) {
      this.$http.wishList[WISH_MODULE[this.activeValue].GetUrl](row.id).then(res => {
        this.detailDialogVisible = true;
        this.formData = res.data;
      }).catch((res) => {
        this.$message.error(res.msg);
      });
    },
    fileListChange(fileList) {
      this.formData.files = fileList.map(item => ({
        name: item.fileName,
        url: item.fileUrl
      }));
    },
    deleteBtn() {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const ids = this.selectData.map(item => item.id);
        this.$http.wishList[WISH_MODULE[this.activeValue].DeleteUrl](ids).then(result => {
          this.$message.success(result.msg);
          this.getTableList();
        }).catch(err => {
          this.$message.error(err.msg);
        });
      });
    },
    contactsBlur () {
      this.$http.wishList.checkIsExist(this.formData.contacts).then((res) => {
        this.formData.demandDepartment = res.data;
      }).catch(() => {
        this.formData.contacts = '';
        this.$message.error('花名不存在');
      });
    },
    saveBtn () {
      this.$refs.formData.validate(valid => {
        if (valid) {
          this.saveLoading = true;
          const { allHtml } = this.$refs.TextareaEditor.getHtml();
          const url = this.formType === 'create' ? 'CreateUrl' : 'UpdateUrl';
          this.$http.wishList[WISH_MODULE[this.activeValue][url]]({
            ...this.formData,
            productDetail: allHtml.trim(),
            module: this.activeValue
          }).then(() => {
            this.$message.success('操作成功');
            this.dialogVisible = false;
            this.getTableList();
          }).catch((res) => {
            this.$message.error(res.msg);
          }).finally(() => {
            this.saveLoading = false;
          });
        }
      });
    },
    createBtn () {
      this.dialogVisible = true;
      this.formData = {
        module: '',
        productName: '',
        izCustomized: '',
        customizedDirection: '',
        quantity: '',
        expectedDeliveryDate: '',
        material: '',
        technology: '',
        referenceDirection: '',
        colorRequire: '',
        arrivalWarehouse: '',
        budgetUnitPrice: '',
        contacts: '',
        demandDepartment: '',
        remark: '',
        productDetail: '',
        files: []
      };
      this.formType = 'create';
      this.dialogTitle = `新增【${this.activeName}】心愿单`;
    },
    updateBtn () {
      this.$http.wishList[WISH_MODULE[this.activeValue].GetUrl](this.selectData[0].id).then(res => {
        this.dialogVisible = true;
        this.formType = 'update';
        this.dialogTitle = `修改【${this.activeName}】心愿单: ${this.selectData[0].code}`;
        this.formData = res.data;
        this.$nextTick(() => {
          this.$refs.uploadMultipleRef.fileList = (res.data.files || []).map(item => ({
            fileName: item.name,
            fileUrl: item.url
          }));
          this.$refs.TextareaEditor.setHtml(res.data.productDetail);
        });
      }).catch((res) => {
        this.$message.error(res.msg);
      });
    },
    getTableList () {
      this.tableLoading = true;
      this.$http.wishList[WISH_MODULE[this.activeValue].ListUrl]({
        ...this.tableParam,
        data: {
          queryStr: this.queryStr
        }
      }).then(res => {
        this.tableData = res.data;
      }).catch((res) => {
        this.$message.error(res.msg);
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    onReset() {
      this.queryStr = '';
      this.tableParam.pageNo = 1;
      this.getTableList();
    },
    onSearch() {
      this.tableParam.pageNo = 1;
      this.getTableList();
    },
    pageSizeChange(pageNo, pageSize) {
      this.tableParam.pageNo = pageNo;
      this.tableParam.pageSize = pageSize;
      this.getTableList();
    },
    // table选择框
    selectChange(arr) {
      this.selectData = arr;
    },
  },
}
</script>
